export type PreviewCaptureFormat = 'jpeg' | 'png';

export type PreviewCaptureOptions = {
  format: PreviewCaptureFormat;
  quality?: number;
  signal?: AbortSignal;
};

export type PreviewCaptureResult = {
  base64: string;
  mimeType: 'image/jpeg' | 'image/png';
  width: number;
  height: number;
};

export type PreviewCaptureHandler = (
  options: PreviewCaptureOptions,
) => Promise<PreviewCaptureResult>;

let handler: PreviewCaptureHandler | null = null;

export function registerTemplatePreviewCapture(fn: PreviewCaptureHandler): () => void {
  handler = fn;
  return () => {
    if (handler === fn) {
      handler = null;
    }
  };
}

export function captureTemplatePreview(
  options: PreviewCaptureOptions,
): Promise<PreviewCaptureResult> {
  if (!handler) {
    return Promise.reject(new Error('Template Builder preview capture is not available.'));
  }
  return handler(options);
}

export function isTemplatePreviewCaptureRegistered(): boolean {
  return handler != null;
}
